<template>
    <table class="table table-vertical-center table-hover" :key="iteration">
        <thead>
        <tr>
            <th>Youbuyda field</th>
            <th>{{ __('general.description') }}</th>
            <th class="d-none d-lg-table-cell" />
            <th>Your column</th>
        </tr>
        </thead>
        <tbody>
        <StockMappingTableRow v-for="(assignedColumn, youbuydaField) in mapping"
                              :key="youbuydaField"
                              :assigned-column="assignedColumn"
                              :youbuyda-field="youbuydaField"
                              :example-values="exampleValues"
                              :identifier="identifierType"
                              :is-optional="isOptionalField(youbuydaField)"
                              @change="updateMapping"
                              @delete="removeField"
        />
        <tr>
            <td colspan="4">
                <AddColumnDropdownButton :available-fields="unmappedOptionalColumns"
                                         @add="addUnmappedOptionalField"
                />
            </td>
        </tr>
        </tbody>
    </table>
</template>

<script>
import Badge from "../../Badge.vue";
import StockMappingTableRow from "./StockMappingTableRow.vue";
import AddColumnDropdownButton from "./AddColumnDropdownButton.vue";

export default {
    components: {AddColumnDropdownButton, StockMappingTableRow, Badge},

    props: {
        value: Object,
        exampleValues: Object,
        identifierType: String
    },

    data() {
        return {
            mandatoryColumns: [
                'identifier',
                'quantity',
                'price',
            ],
            optionalColumns: [
                'base_price',
                'base_unit',
                'currency',
                'tax_rate',
                'channels',
                'price_reduced',
                'shipping_cost',
                'shipping_time',
                'in_store_article_id',
            ],
            iteration: 0,
            mapping: this.value
        }
    },

    mounted() {
        for (let mandatoryColumn of this.mandatoryColumns) {
            if (!this.mapping.hasOwnProperty(mandatoryColumn)) {
                this.mapping[mandatoryColumn] = null;
            }
        }
        this.iteration++;
    },

    methods: {
        isOptionalField(field) {
            return this.optionalColumns.includes(field)
        },

        updateMapping(youbuydaField, assignedColumn) {
            this.$set(this.mapping, youbuydaField, assignedColumn);
            this.sendUpdatedValuesToParent();
        },

        addUnmappedOptionalField(field) {
            this.$set(this.mapping, field, null);
            this.sendUpdatedValuesToParent();
        },

        removeField(fieldToRemove){
            let fieldsToKeep = {};
            for(let key of Object.keys(this.mapping)){
                if(key !== fieldToRemove){
                    fieldsToKeep[key] = this.mapping[key];
                }
            }
            this.$set(this, 'mapping', fieldsToKeep);
            this.sendUpdatedValuesToParent();
        },

        sendUpdatedValuesToParent(){
            this.$emit('input', this.mapping);
            this.iteration++;
        }
    },

    computed: {
        unmappedOptionalColumns() {
            let unmapped = [];
            for (let optionalColumn of this.optionalColumns) {
                if (!this.mapping.hasOwnProperty(optionalColumn)) {
                    unmapped.push(optionalColumn);
                }
            }
            return unmapped;
        }
    }
}
</script>
